import React, { Component, useState } from 'react'

import { Tab, Label } from '@res/styledComponents/index'
import FlexContainer from '@components/common/FlexContainer'
import { GroupOrdersPage, GroupOrdersCalendar } from '@containers/groupOrders'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import {
  EditGroupOrderDeliveryFeeSettingsModal,
  EditGroupOrderStaffingFeeSettingsModal,
  GroupOrdersSecheduleSettings,
  NotificationsSettingsView,
  EditClientSettingsGuestOrderConfigModal,
  EditGroupOrderCustomServiceFeesModal,
} from '@components/groupOrders'
import Sidebar from '@components/sidebar/Sidebar'
import SidebarSearch from '@components/sidebar/SidebarSearch'
import SidebarListItem from '@components/sidebar/SidebarListItem'
import AuthorizedDisplay from '@containers/common/auth/AuthorizedDisplay'
import YSpacing from '@components/common/YSpacing'
import XSpacing from '@components/common/XSpacing'
import Panel from '@components/common/Panel'
import Dropdown from '@components/common/form/Dropdown'
import GroupOrderSchedulePlanner from '@containers/groupOrders/SchedulePlanner/GroupOrderSchedulePlanner'
import UniversalMenuExplorer from '@containers/groupOrders/UniversalMenuExplorer/UniversalMenuExplorer'
import {
  GroupOrderReportsPage,
  GroupOrderReviewsReportsPage,
  GroupOrderUniversalMenusReportsPage,
} from '@containers/groupOrders'
import {
  ValidateClientSettings,
  ValidateClientGlobalSettings,
} from '../../../utils/groupOrderUtils'
import { ValidationsModal } from '@components/groupOrders'
import {
  ClientGlobalSettings,
  ClientSettings,
  GuestOrderConfig,
  UniversalMenuConfig,
  GroupOrderCustomServiceFeeSettings,
} from '@types'
import Input from '@components/common/form/Input'
import Button from '@components/common/form/Button'
import services from '@services'
import { useMutation, useQuery } from 'react-query'
const { RestService } = services

enum WarningsModalEntity {
  CLIENT_SETTINGS = 'CLIENT_SETTINGS',
  CLIENT_GLOBAL_SETTINGS = 'CLIENT_GLOBAL_SETTINGS',
}

enum ActiveTab {
  CLIENT = 'CLIENT',
  REPORTS = 'REPORTS',
  SCHEDULE_PLANNER = 'SCHEDULE_PLANNER',
  UNIVERSAL_MENU_EXPLORER = 'UNIVERSAL_MENU_EXPLORER',
}

enum ActiveClientSubTab {
  DETAILS = 'DETAILS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  SCHEDULE_SETTINGS = 'SCHEDULE_SETTINGS',
  CALENDAR = 'CALENDAR',
  SCIM = 'SCIM',
}

enum ActiveSidebar {
  GENERAL = 'GENERAL',
  CLIENT = 'CLIENT',
}

type Props = {
  client: any
  headquarter: number
  currentHq: any
  routedFromSearch: boolean
  location: any
  groupOrderPage: any
  clientGlobalSettings: any
  loadAccounts: any
  loadAccount: any
  loadHeadquarters: any
  searchSlackAuthData: any
  searchPopUpCustomers: any
  setGroupOrderPage: any
  searchClientSettings: any
  getClientGlobalSettings: any
  saveClientSettings: any
  saveClientGlobalSettings: any
  saveUniversalMenuConfig: any
  saveStaffingFeeSettings: any
  saveCustomServiceFeeSettings: any
  displayFailureMessage: any
  newClientSettings: any
  newClientGlobalSettings: any
  newScheduleSettings: any
}

type State = {
  activeTab: ActiveTab
  activeClientSubTab: ActiveClientSubTab
  activeSidebar: ActiveSidebar
  accounts: any
  account: any
  search: string
  clientSettings: ClientSettings[]
  savedClientSettings: any
  selectedIndex: number
  clientGlobalSettings: any
  page: string
  savedClientGlobalSettings: any
  warningsModalOpen: boolean
  warningsModalEntity: WarningsModalEntity | null
  warningsModalClientGlobalSettings: any
  validationErrors: string[]
  validationWarnings: string[]
  sideBarVisible: boolean
  deliveryFeeSettingsModalOpen: boolean
  staffingFeeSettingsModalOpen: boolean
  customServiceFeesModalOpen: boolean
  guestOrderConfigModalOpen: boolean
}

class GroupOrdersMaster extends Component<Props, State> {
  state: State = {
    activeTab: ActiveTab.CLIENT,
    activeClientSubTab: ActiveClientSubTab.DETAILS,
    activeSidebar: ActiveSidebar.GENERAL,
    accounts: [],
    account: undefined,
    search: '',
    page: '',
    // NOTE: we need to distinguish between saved clientSettings (state in backend) vs
    // staged but un-saved clientSettings on client
    clientSettings: [],
    savedClientSettings: [],
    selectedIndex: 0,
    // NOTE: we need to distinguish between saved clientGlobalSettings (state in backend) vs
    // staged but un-saved clientGlobalSettings on client
    clientGlobalSettings: {} as any,
    savedClientGlobalSettings: {},
    warningsModalOpen: false,
    warningsModalEntity: null,
    warningsModalClientGlobalSettings: null,
    validationErrors: [],
    validationWarnings: [],
    sideBarVisible: true,
    deliveryFeeSettingsModalOpen: false,
    staffingFeeSettingsModalOpen: false,
    customServiceFeesModalOpen: false,
    guestOrderConfigModalOpen: false,
  } as State
  searchTimer: ReturnType<typeof setTimeout> | undefined = undefined

  componentDidMount() {
    const {
      client,
      routedFromSearch,
      setGroupOrderPage,
      location,
      loadHeadquarters,
    } = this.props

    loadHeadquarters()

    const newState = { account: client, activeTab: this.state.activeTab }
    if (routedFromSearch) {
      newState.activeTab = ActiveTab.CLIENT
      this.loadClient(client)
    }
    this.setState(newState)

    const pathBreakdown = location.pathname.match(
      /\/group-orders\/([^/]*)\/([^/]*)/,
    )
    if (pathBreakdown && pathBreakdown.length > 2) {
      this.setState({ activeSidebar: ActiveSidebar.CLIENT })
      setGroupOrderPage({
        account: { id: pathBreakdown[1] },
        date: pathBreakdown[2],
      })
      this.initClientFromAR(pathBreakdown[1])
    }
  }

  flashError = (message: string) =>
    services.UIService.FlashMessage.displayFailureMessage(message)

  onCloseWarningsModal = () => {
    this.setState({
      warningsModalOpen: false,
      warningsModalEntity: null,
      warningsModalClientGlobalSettings: null,
      validationErrors: [],
      validationWarnings: [],
    })
  }

  toggleDeliveryFeeSettingsModal = (value: boolean) => {
    this.setState({ deliveryFeeSettingsModalOpen: value })
  }

  toggleStaffingFeeSettingsModal = (value: boolean) => {
    this.setState({ staffingFeeSettingsModalOpen: value })
  }

  toggleCustomServiceFeesModal = (value: boolean) => {
    this.setState({ customServiceFeesModalOpen: value })
  }

  toggleGuestOrderConfigModal = (value: boolean) => {
    this.setState({ guestOrderConfigModalOpen: value })
  }

  updateClientSettings = (clientSettings: any) => {
    this.setState({ clientSettings })
  }

  updateClientGlobalSettings = (clientGlobalSettings: any) => {
    this.setState({ clientGlobalSettings })
  }

  updateSelectedIndex = (selectedIndex: number) => {
    this.setState({ selectedIndex })
  }

  onSaveGuestOrderConfig = (guestOrderConfig: GuestOrderConfig) => {
    const { clientSettings: clientSettingsCollection, selectedIndex: i } =
      this.state

    const settings = clientSettingsCollection[i]

    if (!settings) {
      return
    }

    const nextSettings = {
      ...settings,
      guestOrderConfig,
    }

    this.updateClientSettings([
      ...clientSettingsCollection.slice(0, i),
      nextSettings,
      ...clientSettingsCollection.slice(i + 1),
    ])
  }

  initClientFromAR = async (accountId: string) => {
    const accounts = await this.props.loadAccounts({
      search: '',
      account_serializer: true,
    })
    const account = await this.props.loadAccount(accountId)
    if (account) {
      this.setState({
        accounts,
        account,
        page: 'Clients',
        activeTab: ActiveTab.CLIENT,
      })
    }
  }

  onSearch = (e: any) => {
    const search = e.target.value
    this.setState({ search }, () => {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(async () => {
        const accounts = await this.props.loadAccounts({
          search,
          account_serializer: true,
        })
        this.setState({ accounts })
      }, 550)
    })
  }

  onSaveClientSettings = async (skipWarnings = false) => {
    const { saveClientSettings } = this.props
    const {
      clientSettings: clientSettingsCollection,
      selectedIndex: i,
      savedClientGlobalSettings,
    } = this.state
    const settings = clientSettingsCollection[i]

    const { errors, warnings } = ValidateClientSettings(
      settings,
      savedClientGlobalSettings as ClientGlobalSettings,
      this.state.savedClientSettings,
    )

    if (errors.length || (warnings.length && !skipWarnings)) {
      this.setState({
        warningsModalOpen: true,
        warningsModalEntity: WarningsModalEntity.CLIENT_SETTINGS,
        validationErrors: errors,
        validationWarnings: warnings,
      })

      return
    }

    // Close and reset warnings modal if open
    this.setState({
      warningsModalOpen: false,
      validationErrors: [],
      validationWarnings: [],
    })

    const result = await saveClientSettings(settings, settings.client.name)
    if (result) {
      const updatedSettings = [
        ...clientSettingsCollection.slice(0, i),
        result,
        ...clientSettingsCollection.slice(i + 1),
      ]
      this.setState({
        clientSettings: [...updatedSettings],
        savedClientSettings: [...updatedSettings],
      })
    }
  }

  onSaveUniversalMenuConfig = async (config: UniversalMenuConfig) => {
    const { saveUniversalMenuConfig } = this.props
    const { clientSettings: clientSettingsCollection, selectedIndex: i } =
      this.state

    const settings = clientSettingsCollection[i]
    const result = await saveUniversalMenuConfig(settings.id, config)
    if (result) {
      settings.universalMenuConfig = result
      const updatedSettings = [
        ...clientSettingsCollection.slice(0, i),
        settings,
        ...clientSettingsCollection.slice(i + 1),
      ]
      this.setState({
        clientSettings: [...updatedSettings],
      })

      return true
    }
  }

  onClientSettingsUpdateSuccess = (cs: ClientSettings) => {
    const { clientSettings: clientSettingsCollection, selectedIndex: i } =
      this.state

    const updatedSettings = [
      ...clientSettingsCollection.slice(0, i),
      cs,
      ...clientSettingsCollection.slice(i + 1),
    ]
    this.setState({
      clientSettings: [...updatedSettings],
      savedClientSettings: [...updatedSettings],
    })
  }

  // TODO: validate that value passed as `clientGlobalSettings` can be a partial update
  // and won't clear data from state if so. Another option is to use the `result` from update
  // call to api as new `clientGlobalSettings` value of state
  onSaveClientGlobalSettings = async (
    clientGlobalSettings: any,
    skipWarnings = false,
  ) => {
    const { displayFailureMessage, saveClientGlobalSettings, headquarter } =
      this.props
    const { account, savedClientSettings: clientSettingsCollection } =
      this.state

    if (!clientGlobalSettings.headquarter && headquarter) {
      clientGlobalSettings.headquarter = headquarter
    } else if (!clientGlobalSettings.headquarter) {
      displayFailureMessage(
        "Missing Headquarter on the Client's Global Settings",
      )

      return
    }

    const { errors, warnings } = ValidateClientGlobalSettings(
      clientGlobalSettings,
      clientSettingsCollection,
    )

    if (errors.length || (warnings.length && !skipWarnings)) {
      this.setState({
        warningsModalOpen: true,
        warningsModalEntity: WarningsModalEntity.CLIENT_GLOBAL_SETTINGS,
        warningsModalClientGlobalSettings: clientGlobalSettings,
        validationErrors: errors,
        validationWarnings: warnings,
      })

      return
    }

    // Close and reset warnings modal if open
    this.onCloseWarningsModal()

    const result = await saveClientGlobalSettings(
      clientGlobalSettings,
      (account as any).name,
    )

    if (result) {
      this.setState({
        clientGlobalSettings: { ...result },
        savedClientGlobalSettings: { ...result },
        // Ensure modals for partial updates to client global settings are closed
        deliveryFeeSettingsModalOpen: false,
      })
    }

    return result
  }

  createClientGlobalSettings = async () => {
    const { headquarter, displayFailureMessage } = this.props
    const clientGlobalSettings = this.state.clientGlobalSettings as any

    if (!clientGlobalSettings.headquarter && headquarter) {
      clientGlobalSettings.headquarter = headquarter
    } else {
      displayFailureMessage(
        "Missing Headquarter on the Client's Global Settings",
      )

      return null
    }

    const nextClientGlobalSettings =
      await this.onSaveClientGlobalSettings(clientGlobalSettings)
    if (nextClientGlobalSettings) {
      return nextClientGlobalSettings
    } else {
      // Creation of global settings failed, bail here
      return null
    }
  }

  onSaveCustomServiceFeeSettings = async (
    globalConfig: GroupOrderCustomServiceFeeSettings | null,
    locationConfigs: Record<string, GroupOrderCustomServiceFeeSettings | null>,
  ) => {
    const { saveCustomServiceFeeSettings } = this.props

    const clientGlobalSettings = this.state.clientGlobalSettings as any

    let clientGlobalSettingsId = clientGlobalSettings.id
    // Check if clientGlobalSettings exists (has id) first. If not create, then save new properties
    if (!clientGlobalSettingsId) {
      const nextClientGlobalSettings = await this.createClientGlobalSettings()
      if (!nextClientGlobalSettings) {
        return false
      }
      clientGlobalSettingsId = nextClientGlobalSettings.id
    }

    const result = await saveCustomServiceFeeSettings(
      clientGlobalSettingsId,
      globalConfig,
      locationConfigs,
    )
    if (result) {
      const nextClientSettingsMap: any = {}
      this.state.clientSettings.forEach((cs: any) => {
        const updatedClientSettings = result.clientSettingsMap[cs.id]
        const nextClientSettings = updatedClientSettings || cs
        nextClientSettingsMap[cs.id] = nextClientSettings
      })

      this.setState({
        clientSettings: Object.values(nextClientSettingsMap),
        clientGlobalSettings: result.clientGlobalSettings,
        savedClientGlobalSettings: result.clientGlobalSettings,
        customServiceFeesModalOpen: false,
      })
    }

    return !!result
  }

  onSaveStaffingFeeSettings = async (
    globalStaffingFeeSettings: any,
    locationsConfig: any,
  ) => {
    const { saveStaffingFeeSettings } = this.props

    const clientGlobalSettings = this.state.clientGlobalSettings as any

    let clientGlobalSettingsId = clientGlobalSettings.id
    // Check if clientGlobalSettings exists (has id) first. If not create, then save new properties
    if (!clientGlobalSettingsId) {
      const nextClientGlobalSettings = await this.createClientGlobalSettings()
      if (!nextClientGlobalSettings) {
        return
      }
      clientGlobalSettingsId = nextClientGlobalSettings.id
    }
    const result = await saveStaffingFeeSettings(
      clientGlobalSettingsId,
      globalStaffingFeeSettings,
      locationsConfig,
    )
    if (result) {
      const nextClientSettingsMap: any = {}
      this.state.clientSettings.forEach((cs: any) => {
        const updatedClientSettings = result.clientSettingsMap[cs.id]
        const nextClientSettings = updatedClientSettings || cs
        nextClientSettingsMap[cs.id] = nextClientSettings
      })

      this.setState({
        clientSettings: Object.values(nextClientSettingsMap),
        clientGlobalSettings: result.clientGlobalSettings,
        savedClientGlobalSettings: result.clientGlobalSettings,
        staffingFeeSettingsModalOpen: false,
      })
    }

    return result
  }

  onSaveWithWarnings = () => {
    const { warningsModalEntity, warningsModalClientGlobalSettings } =
      this.state
    if (warningsModalEntity === WarningsModalEntity.CLIENT_SETTINGS) {
      this.onSaveClientSettings(true)
    } else if (
      warningsModalEntity === WarningsModalEntity.CLIENT_GLOBAL_SETTINGS
    ) {
      this.onSaveClientGlobalSettings(warningsModalClientGlobalSettings, true)
    }
  }

  renderSideBar() {
    const { account, accounts, page, activeSidebar } = this.state
    const { setGroupOrderPage } = this.props
    const sidebarPages = ['Clients']

    if (activeSidebar !== ActiveSidebar.GENERAL) {
      return (
        <Sidebar heading="Clients">
          <SidebarListItem
            onClick={() => {
              this.setState({ activeSidebar: ActiveSidebar.GENERAL })
            }}
          >
            {'< Back'}
          </SidebarListItem>
          <SidebarSearch label="Search Clients" onChange={this.onSearch} />
          <div className="sidebar-scroll">
            {accounts.map((acct: any) => {
              const selected = account && acct.id === (account as any).id

              return (
                <SidebarListItem
                  key={acct.id}
                  isSelected={selected}
                  onClick={() => {
                    this.setState(
                      {
                        account: acct,
                        activeTab: ActiveTab.CLIENT,
                        activeClientSubTab: ActiveClientSubTab.DETAILS,
                      },
                      () => this.loadClient(acct),
                    )
                  }}
                >
                  {acct.name}
                </SidebarListItem>
              )
            })}
          </div>
        </Sidebar>
      )
    }

    return (
      <Sidebar heading="Group Orders">
        <div>
          <FaArrowCircleLeft
            style={{ marginLeft: 'auto', marginRight: 0 }}
            onClick={() => this.setState({ sideBarVisible: false })}
          />
        </div>
        <div className="sidebar-scroll">
          {sidebarPages.map((p) => {
            const selected = p === page

            return (
              <SidebarListItem
                key={p}
                isSelected={selected}
                onClick={() => {
                  setGroupOrderPage({ account: account })
                  this.setState(
                    {
                      account: account,
                      page: p,
                      activeSidebar: ActiveSidebar.CLIENT,
                    },
                    () => this.loadClient(account),
                  )
                }}
              >
                {p}
              </SidebarListItem>
            )
          })}
          <SidebarListItem
            isSelected={'schedule' === page}
            onClick={() => {
              this.setState({
                page: 'schedule',
                activeTab: ActiveTab.SCHEDULE_PLANNER,
                account: undefined,
              })
            }}
          >
            Schedule Planner
          </SidebarListItem>
          <SidebarListItem
            isSelected={page === 'universal-menu-explorer'}
            onClick={() => {
              this.setState({
                page: 'universal-menu-explorer',
                activeTab: ActiveTab.UNIVERSAL_MENU_EXPLORER,
                account: undefined,
              })
            }}
          >
            Universal Menus Preview
          </SidebarListItem>
          <AuthorizedDisplay
            roles={[
              'developer',
              'master admin',
              'sales lead',
              'sales rep',
              'chef lead',
            ]}
          >
            <SidebarListItem
              isSelected={'reports' === page}
              onClick={() => {
                this.setState({ page: 'reports', activeTab: ActiveTab.REPORTS })
              }}
            >
              Reports
            </SidebarListItem>
          </AuthorizedDisplay>
        </div>
      </Sidebar>
    )
  }

  loadClient = (client: any) => {
    ;(async (client) => {
      if (!client) {
        return
      }
      const {
        currentHq,
        searchClientSettings,
        getClientGlobalSettings,
        newClientSettings,
        newClientGlobalSettings,
        groupOrderPage,
        displayFailureMessage,
      } = this.props
      if (!currentHq) {
        displayFailureMessage(
          'Unable to identify your current headquarters. Please log out and log back in.',
        )

        return
      }
      const { clientSettingsId } = groupOrderPage || {}
      const newState = {} as Pick<State, keyof State>

      const clientSettings = await searchClientSettings({
        clientPin: client.pin,
      })
      if (clientSettings) {
        newState.clientSettings = [...clientSettings]
        newState.savedClientSettings = [...clientSettings]
        newState.selectedIndex = 0
        if (clientSettings.length === 0) {
          newState.clientSettings = [
            newClientSettings({ headquarter: currentHq, client }),
          ]
        } else {
          const index = clientSettings.findIndex(
            (s: any) => s.id === clientSettingsId,
          )
          if (index >= 0) {
            newState.selectedIndex = index
          }
        }
      }

      const clientGlobalSettings = await getClientGlobalSettings({
        clientId: client.id,
      })

      newState.clientGlobalSettings = { ...clientGlobalSettings }
      newState.savedClientGlobalSettings = { ...clientGlobalSettings }

      if (!(clientGlobalSettings && clientGlobalSettings.clientId)) {
        const newGlobalSettings = newClientGlobalSettings({
          headquarter: currentHq,
          client,
        })
        newState.clientGlobalSettings = newGlobalSettings
      }

      this.setState(newState)
    })(client)
  }

  renderClientContent = () => {
    const {
      account,
      clientSettings,
      selectedIndex,
      clientGlobalSettings,
      activeClientSubTab,
    } = this.state
    const { newScheduleSettings, displayFailureMessage } = this.props

    if (!account) {
      return <></>
    }

    switch (activeClientSubTab) {
      case ActiveClientSubTab.DETAILS:
        return (
          <GroupOrdersPage
            client={account}
            clientSettings={clientSettings}
            selectedIndex={selectedIndex}
            clientGlobalSettings={clientGlobalSettings}
            updateClientSettings={this.updateClientSettings}
            updateClientGlobalSettings={this.updateClientGlobalSettings}
            updateSelectedIndex={this.updateSelectedIndex}
            onSaveClientSettings={this.onSaveClientSettings}
            onSaveClientGlobalSettings={this.onSaveClientGlobalSettings}
            onSaveUniversalMenuConfig={this.onSaveUniversalMenuConfig}
            toggleDeliveryFeeSettingsModal={this.toggleDeliveryFeeSettingsModal}
            toggleStaffingFeeSettingsModal={this.toggleStaffingFeeSettingsModal}
            toggleCustomServiceFeesModal={this.toggleCustomServiceFeesModal}
            toggleGuestOrderConfigModal={this.toggleGuestOrderConfigModal}
          />
        )
      case ActiveClientSubTab.NOTIFICATIONS:
        return (
          clientSettings[selectedIndex] && (
            <NotificationsSettingsView
              clientSettings={clientSettings[selectedIndex] as ClientSettings}
              displayFailureMessage={displayFailureMessage}
              saveClientSettings={this.props.saveClientSettings}
              onClientSettingsUpdateSuccess={this.onClientSettingsUpdateSuccess}
              searchSlackAuthData={this.props.searchSlackAuthData}
              searchPopUpCustomers={this.props.searchPopUpCustomers}
            />
          )
        )
      case ActiveClientSubTab.SCHEDULE_SETTINGS:
        return (
          <GroupOrdersSecheduleSettings
            selectedIndex={selectedIndex}
            clientSettings={clientSettings}
            newScheduleSettings={newScheduleSettings}
            displayFailureMessage={displayFailureMessage}
            updateClientSettings={this.updateClientSettings}
            onSaveClientSettings={this.onSaveClientSettings}
          />
        )
      case ActiveClientSubTab.CALENDAR:
        return (
          <GroupOrdersCalendar
            client={account}
            clientSettings={clientSettings}
            clientGlobalSettings={clientGlobalSettings}
            selectedIndex={selectedIndex}
          />
        )
      case ActiveClientSubTab.SCIM:
        return (
          <ScimSettings
            accountId={account.id}
            clientSettings={clientSettings}
            onError={this.flashError}
          />
        )
      default:
        return null
    }
  }

  render() {
    const {
      account,
      activeTab,
      activeClientSubTab,
      clientSettings,
      selectedIndex,
      clientGlobalSettings,
    } = this.state

    return (
      <div className="flex flex-row w-full">
        {' '}
        {/* Similar to the styling on PageBody */}
        {this.state.sideBarVisible && this.renderSideBar()}
        {!this.state.sideBarVisible && (
          <div className="pt-5 pr-10">
            <button>
              <FaArrowCircleRight
                onClick={() => this.setState({ sideBarVisible: true })}
              />
            </button>
          </div>
        )}
        {/* PANEL */}
        <div
          className={`${
            this.state.sideBarVisible ? 'sidebar-body' : ''
          } w-[1400px] overflow-x-scroll mt-3`}
        >
          {' '}
          {/* Need to override width: 100% to get scrolling to work right */}
          <div className="sidebar-body-inner">
            <div
              style={{ width: '100%', position: 'static', overflowX: 'scroll' }}
            >
              {account ? (
                <FlexContainer>
                  <Panel>
                    <Label>Client</Label>
                    <p>{(account as any).name}</p>
                    <YSpacing height="20px" />
                    <Dropdown
                      label="Selected Location"
                      value={selectedIndex}
                      onChange={(e) =>
                        this.updateSelectedIndex(Number(e.target.value) || 0)
                      }
                    >
                      {clientSettings.map((settings: any, i: number) => (
                        <option key={settings.id} value={i}>
                          {settings.name ||
                            (account
                              ? `${(account as any).name} (default)`
                              : '')}
                        </option>
                      ))}
                    </Dropdown>
                  </Panel>
                </FlexContainer>
              ) : (
                <></>
              )}
              {activeTab == ActiveTab.CLIENT && (
                <FlexContainer>
                  <Tab
                    onClick={() =>
                      this.setState({
                        activeClientSubTab: ActiveClientSubTab.DETAILS,
                      })
                    }
                    isActive={activeClientSubTab === ActiveClientSubTab.DETAILS}
                  >
                    Client Details
                  </Tab>
                  <Tab
                    onClick={() =>
                      this.setState({
                        activeClientSubTab: ActiveClientSubTab.NOTIFICATIONS,
                      })
                    }
                    isActive={
                      activeClientSubTab === ActiveClientSubTab.NOTIFICATIONS
                    }
                  >
                    Notification Settings
                  </Tab>
                  <Tab
                    onClick={() =>
                      this.setState({
                        activeClientSubTab:
                          ActiveClientSubTab.SCHEDULE_SETTINGS,
                      })
                    }
                    isActive={
                      activeClientSubTab ===
                      ActiveClientSubTab.SCHEDULE_SETTINGS
                    }
                  >
                    Default Schedule Settings
                  </Tab>
                  <Tab
                    onClick={() =>
                      this.setState({
                        activeClientSubTab: ActiveClientSubTab.CALENDAR,
                      })
                    }
                    isActive={
                      activeClientSubTab === ActiveClientSubTab.CALENDAR
                    }
                  >
                    Calendar
                  </Tab>
                  <Tab
                    onClick={() =>
                      this.setState({
                        activeClientSubTab: ActiveClientSubTab.SCIM,
                      })
                    }
                    isActive={activeClientSubTab === ActiveClientSubTab.SCIM}
                  >
                    SCIM
                  </Tab>
                </FlexContainer>
              )}

              <YSpacing height="20px" />
              {this.renderClientContent()}
              {activeTab === ActiveTab.REPORTS && (
                <FlexContainer flexWrap={'wrap'}>
                  <GroupOrderReportsPage />
                  <XSpacing width="20px" />
                  <GroupOrderReviewsReportsPage />
                  <XSpacing width="20px" />
                  <GroupOrderUniversalMenusReportsPage />
                </FlexContainer>
              )}
              {activeTab === ActiveTab.SCHEDULE_PLANNER && (
                <GroupOrderSchedulePlanner />
              )}
              {activeTab === ActiveTab.UNIVERSAL_MENU_EXPLORER && (
                <UniversalMenuExplorer />
              )}
              <YSpacing height="20px" />
            </div>
          </div>
        </div>
        {this.state.deliveryFeeSettingsModalOpen && (
          <EditGroupOrderDeliveryFeeSettingsModal
            clientName={this.props.client ? this.props.client.name : ''}
            clientGlobalSettings={clientGlobalSettings}
            onSaveClientGlobalSettings={this.onSaveClientGlobalSettings}
            closeModal={() => this.toggleDeliveryFeeSettingsModal(false)}
            flashError={this.flashError}
          />
        )}
        {this.state.customServiceFeesModalOpen && (
          <EditGroupOrderCustomServiceFeesModal
            client={account}
            clientGlobalSettings={clientGlobalSettings}
            clientSettingsCollection={clientSettings}
            onSaveCustomServiceFeeSettings={this.onSaveCustomServiceFeeSettings}
            closeModal={() => this.toggleCustomServiceFeesModal(false)}
            flashError={this.flashError}
          />
        )}
        {this.state.staffingFeeSettingsModalOpen && (
          <EditGroupOrderStaffingFeeSettingsModal
            clientName={this.props.client ? this.props.client.name : ''}
            clientGlobalSettings={clientGlobalSettings}
            clientSettingsCollection={clientSettings}
            onSaveStaffingFeeSettings={this.onSaveStaffingFeeSettings}
            closeModal={() => this.toggleStaffingFeeSettingsModal(false)}
            flashError={this.flashError}
          />
        )}
        {this.state.guestOrderConfigModalOpen && (
          <EditClientSettingsGuestOrderConfigModal
            guestOrderConfig={
              clientSettings[selectedIndex]?.guestOrderConfig || null
            }
            onSave={this.onSaveGuestOrderConfig}
            closeModal={() => this.toggleGuestOrderConfigModal(false)}
          />
        )}
        {this.state.warningsModalOpen && (
          <ValidationsModal
            onClose={this.onCloseWarningsModal}
            onSave={this.onSaveWithWarnings}
            validationErrors={this.state.validationErrors}
            validationWarnings={this.state.validationWarnings}
          />
        )}
      </div>
    )
  }
}

function ScimSettings({
  accountId,
  clientSettings,
  onError,
}: {
  accountId: string
  clientSettings: {
    id: string
    name: string
  }[]
  onError: (message: string) => void
}) {
  const [addToAllLocsChecked, setAddToAllLocsChecked] = useState(false)

  type orgResponse = {
    organization?: {
      Id: string
      Name: string
    }
    addNewUsersToAllGOLocations: boolean
    goLocationExceptions: string[]
    sendGOWelcomeEmailToNewUsers: boolean
    goNotRemind: boolean
  }

  const orgQuery = useQuery(
    ['scimOrg', accountId],
    async (): Promise<orgResponse> => {
      const res = await RestService.get(
        `/scim/internal/client/${accountId}/linked-organization`,
      )

      return res
    },
  )

  const orgUnlinkMutation = useMutation(
    async (): Promise<any> => {
      const res = await RestService.put(
        `/scim/internal/client/${accountId}/unlink-organization`,
      )

      return res
    },
    {
      onSuccess: () => {
        orgQuery.refetch()
      },
      onError: () => {
        onError('Failed to unlink organization')
      },
    },
  )

  const orgMutation = useMutation(
    async (data: {
      organizationId: string
      addNewUsersToAllGOLocations: boolean
      goLocationExceptions: string[]
      sendGOWelcomeEmailToNewUsers: boolean
      goNotRemind: boolean
    }): Promise<any> => {
      const res = await RestService.put(
        `/scim/internal/client/${accountId}/link-organization`,
        data,
      )

      return res
    },
    {
      onSuccess: () => {
        orgQuery.refetch()
      },
      onError: () => {
        onError('Failed to link organization, make sure it exists in zitadel')
      },
    },
  )

  if (orgQuery.isError) {
    const message =
      (orgQuery.error as any)?.response?.data?.error ||
      'Failed to load linked organization'
    onError(message)
  }

  // We only want real client settings, default locations don't have an id
  clientSettings = clientSettings.filter((cs) => !!cs.id)

  return (
    <Panel width="100%" maxWidth="800px" heading="SCIM Settings">
      {orgQuery.isLoading && <p>Loading...</p>}
      {orgQuery.data?.organization && (
        <div>
          <p>Currently linked to zitadel organization:</p>
          <p>
            <strong>
              {orgQuery.data.organization.Name} (ID:{' '}
              {orgQuery.data.organization.Id})
            </strong>
          </p>
          <p>
            Add new users to all locations:{' '}
            {orgQuery.data.addNewUsersToAllGOLocations ? 'Yes' : 'No'}
          </p>
          {orgQuery.data.addNewUsersToAllGOLocations && (
            <>
              {orgQuery.data.goLocationExceptions.length > 0 && (
                <p>
                  Excluding Locations:{' '}
                  {orgQuery.data.goLocationExceptions
                    .filter((locId) =>
                      clientSettings.some((cs) => cs.id === locId),
                    )
                    .map((locId) => {
                      const loc = clientSettings.find((cs) => cs.id === locId)

                      return loc && loc.name ? loc.name : locId
                    })
                    .join(', ')}
                </p>
              )}
              <p>
                Send GO welcome email to new users:{' '}
                {orgQuery.data.sendGOWelcomeEmailToNewUsers ? 'Yes' : 'No'}
              </p>
              <p>
                Do not send order reminders for new users:{' '}
                {orgQuery.data.goNotRemind ? 'Yes' : 'No'}
              </p>
            </>
          )}
          <YSpacing height="10px" />
          <Button
            label={
              orgUnlinkMutation.isLoading
                ? 'Unlinking...'
                : 'Unlink Organization'
            }
            onClick={() => orgUnlinkMutation.mutate()}
            disabled={orgUnlinkMutation.isLoading}
          />
        </div>
      )}
      {orgQuery.isSuccess && !orgQuery.data?.organization && (
        <form
          onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault()
            const form: HTMLFormElement = e.target as HTMLFormElement
            const formData = new FormData(form)
            const data = Object.fromEntries(formData)
            const organizationId = data['organization_id'] as string
            const addNewUsersToAllGOLocations =
              data['add_new_users_to_all_locations'] === 'on'
            const sendGOWelcomeEmailToNewUsers =
              data['send_welcome_email'] === 'on'
            const goNotRemind = data['go_not_remind'] === 'on'
            const goLocationExceptions = formData.getAll(
              'go_location_exceptions',
            ) as string[]
            orgMutation.mutate({
              organizationId,
              addNewUsersToAllGOLocations,
              goLocationExceptions,
              sendGOWelcomeEmailToNewUsers,
              goNotRemind,
            })
          }}
        >
          <Input
            label="organization_id"
            type="text"
            defaultValue={orgQuery.data?.organization?.Id || ''}
          />
          <div className="flex gap-1 items-center">
            <input
              type="checkbox"
              id="add_new_users_to_all_locations"
              name="add_new_users_to_all_locations"
              checked={addToAllLocsChecked}
              onChange={() => setAddToAllLocsChecked((prev) => !prev)}
            />
            <label className="mt-1" htmlFor="add_new_users_to_all_locations">
              Add new users to all locations
            </label>
          </div>
          {addToAllLocsChecked && (
            <>
              {clientSettings.length > 0 && (
                <div className="flex gap-1 items-center ml-5">
                  <p>Select Locations to Exclude:</p>
                  <select
                    multiple
                    name="go_location_exceptions"
                    id="go_location_exceptions"
                    className="border border-gray-300 rounded p-2"
                    style={{ width: '200px', height: '100px' }}
                  >
                    {clientSettings.map((cs) => (
                      <option key={cs.id} value={cs.id}>
                        {cs.name || 'Default Location'}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="flex gap-1 items-center">
                <input
                  type="checkbox"
                  id="send_welcome_email"
                  name="send_welcome_email"
                  defaultChecked={false}
                />
                <label className="mt-1" htmlFor="send_welcome_email">
                  Send welcome email to new users
                </label>
              </div>
              <div className="flex gap-1 items-center">
                <input
                  type="checkbox"
                  id="go_not_remind"
                  name="go_not_remind"
                  defaultChecked={false}
                />
                <label className="mt-1" htmlFor="go_not_remind">
                  Do not send order reminders for new users
                </label>
              </div>
            </>
          )}
          <div style={{ height: '10px' }} />
          <Button
            label="Save"
            disabled={orgQuery.isLoading || orgMutation.isLoading}
          />
        </form>
      )}
    </Panel>
  )
}

export default GroupOrdersMaster
